
import { HabitsKeys } from '@/i18n/types';

export const habits: Record<HabitsKeys, string> = {
  habits: 'Habits',
  myHabits: 'My Habits',
  newHabit: 'New Habit',
  editHabit: 'Edit Habit',
  deleteHabit: 'Delete Habit',
  habitName: 'Habit Name',
  habitDescription: 'Habit Description',
  frequency: 'Frequency',
  selectDays: 'Select Days',
  categories: 'Categories',
  development: 'Development',
  health: 'Health',
  productivity: 'Productivity',
  learning: 'Learning',
  lifestyle: 'Lifestyle',
  personalDevelopment: 'Personal Development',
  habitTracker: 'Habit Tracker',
  habitsDesc: 'Build positive habits and track your progress.',
  suggestedHabits: 'Suggested Habits',
  suggestedHabitsDesc: 'Select habits from this list that you would like to add to your habits.',
  addSelectedHabits: 'Add Selected Habits',
  noHabitsSelected: 'No habits selected',
  pleaseSelectHabits: 'Please select at least one habit to add.',
  habitsAdded: 'Habits Added',
  multipleHabitsAdded: 'The selected habits have been added to your list.',
  singleHabitAdded: 'The selected habit has been added to your list.',
  errorLoadingSuggested: 'Error loading suggested habits',
  noSuggestedHabits: 'There are no suggested habits available at the moment.',
  loading: 'Loading',
  // New translations
  adminSuggestedHabits: 'Manage Suggested Habits',
  adminSuggestedHabitsDesc: 'Create, edit, or delete suggested habits for users.',
  addSuggestedHabit: 'Add Suggested Habit',
  editSuggestedHabit: 'Edit Suggested Habit',
  enterHabitName: 'Enter habit name',
  enterHabitDescription: 'Enter habit description',
  selectCategory: 'Select category',
  selectFrequency: 'Select frequency',
  cancel: 'Cancel',
  update: 'Update',
  create: 'Create',
  delete: 'Delete',
  category: 'Category',
  daily: 'Daily',
  weekly: 'Weekly',
  monthly: 'Monthly',
  confirmDelete: 'Confirm Delete',
  deleteHabitConfirmation: 'Are you sure you want to delete this suggested habit? This action cannot be undone.',
  habitUpdated: 'Habit Updated',
  habitHasBeenUpdated: 'The habit has been successfully updated.',
  habitCreated: 'Habit Created',
  habitHasBeenCreated: 'The habit has been successfully created.',
  error: 'Error',
  errorSavingHabit: 'An error occurred while saving the habit.',
  habitDeleted: 'Habit Deleted',
  habitHasBeenDeleted: 'The habit has been successfully deleted.',
  errorDeletingHabit: 'An error occurred while deleting the habit.',
  suggestedHabitsFor: 'Suggested Habits for',
  addHabit: 'Add Habit',
  noHabitsAvailable: 'No habits available in this language yet.',
  allLanguages: 'Show All Languages',
  currentLanguageOnly: 'Current Language Only',
  habitCalendar: 'Calendar',
  habitStats: 'Statistics',
  noHabitsYet: 'No habits yet',
};
